// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"4a549d20","87":"e54b66b7","213":"55557c3f","378":"591f48ed","430":"ca17f290","464":"09637464","489":"abb4672a","494":"153f239c","667":"1a78c481","793":"a3c42677","845":"2d2ac7b5"}[chunkId] + ".chunk.js";
};